/**
 * Which filter sets a Target Definition is matched by: it matches when ANY of
 * its criteria sets does. Both matchers and `performanceTiles` route through
 * here. Design and the three non-matcher readers: `decisions.md` §28.
 *
 * THE FALLBACK: a commitment with no criteria set rows is matched by its own
 * flat filter fields, exactly as before criteria sets existed. It makes the
 * migration and deploy safe in either order, and must stay until the flat
 * columns are dropped.
 *
 * NOTE ON FAILING OPEN. When the fallback fires on a commitment whose flat
 * filters are also empty, the matchers treat that as matching EVERY subject,
 * not none (`getConfiguredValidationResults`). So losing a commitment's
 * criteria sets over-counts rather than under-counts. The write path stores
 * set 1 from the flat columns on every upsert, so a commitment never loses
 * all of them.
 *
 * Only the top level is read; a criteria set's own `criteriaSets` is ignored.
 */
export const resolveCriteriaSets = (commitment) => commitment.criteriaSets && commitment.criteriaSets.length > 0
    ? commitment.criteriaSets
    : [commitment];
